export const RouteGetMerchflowsVariants = "/merchflows/variants";

export interface ParamsGetMerchflowsVariants {
  filterConfigId: string;
}

export type ResponseGetMerchflowsVariants = string[];
